import { useQuery, useQueryClient } from '@tanstack/react-query';
import { useEffect } from 'react';
import {
  InfrastructureProjectConfigSearchRequest,
  InfrastructureProjectsApi,
} from 'osep-generator-service-client-v1';
import { IAS_PROJECT_CONFIG_QUERY_KEY } from '../../utils/consts';
import { useApiConfig } from '../useApiConfig';

function useInfraProjectConfigPage(
  searchRequest: InfrastructureProjectConfigSearchRequest = {},
  enabled = true,
) {
  const { getApiConfig, axiosInstance } = useApiConfig();
  const queryClient = useQueryClient();

  const cli = useQuery({
    queryKey: [IAS_PROJECT_CONFIG_QUERY_KEY, searchRequest],
    queryFn: async () => {
      const config = await getApiConfig();
      const infraApi = new InfrastructureProjectsApi(
        config,
        undefined,
        axiosInstance,
      );
      const result = (
        await infraApi.searchInfrastructureProjectConfigs(searchRequest)
      ).data;

      return result;
    },
    enabled: enabled,
  });

  useEffect(() => {
    cli.data?.projectConfigs?.forEach((projectConfig) => {
      queryClient.setQueryData(
        [IAS_PROJECT_CONFIG_QUERY_KEY, projectConfig.projectId],
        projectConfig,
      );
    });
  }, [cli.data, queryClient]);

  return cli;
}

export default useInfraProjectConfigPage;
